import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import RadioButtonsGroup from './radio-buttons-group';
import { QuestionHeading } from './question-heading';

export const RadioButtons = observer(({ ui, handleChange, value, answer }) => {

    const onChange = (event) => {
        handleChange(event.target.value);
    };

    return (
        <div className="section-exam">
            <div className={classes('assessment')}>
                <div className={'assessment-question'}>
                    <QuestionHeading ui={ui} />
                    <RadioButtonsGroup
                        radioOptions={ui.options}
                        onChange={onChange}
                        value={value}
                        answer={answer}
                    />
                </div>
            </div>
        </div>
    );
});
